import { getLocalStorageItem } from '../../../packages/logger/src';
import {
  DISPATCH_STORAGE_EVENTS,
  IntegrationPhoneServicesResponse,
} from '../../../packages/adapter-interfaces/src';
import { getMultiLineLabel } from '../../../packages/widgets/src/utils/handleMultiLineLabel';
import { CallerIdLineType, ILineSelectionInfo } from '../types';
import { Logger } from '../../../packages/logger/src';

/**
 * Resolve a display title for a Phone Services line (localStorage fallback path).
 *
 * Mirrors `PhoneServicesLineService#getLineTitle`. Previously gated by a single
 * org id allowlist; the gate has been removed so every org now sees the
 * user-defined label (when present) preferred over the raw line name.
 */
function getLineTitle(label: string, name: string, fallback: string): string {
  return label || name || fallback;
}

/**
 * Fallback: parse line data from Phone Services localStorage when the primary fetch fails.
 * Cannot determine which line is currently selected (always defaults to L1).
 */
export function parsePhoneServicesFallback(): ILineSelectionInfo[] {
  const phoneServicesData = getLocalStorageItem<IntegrationPhoneServicesResponse>(
    DISPATCH_STORAGE_EVENTS.STORAGE_PHONE_SERVICES_DATA
  );

  if (!phoneServicesData?.data?.payload?.lines) {
    Logger.info('[LineSelection] Phone Services fallback — no lines found in localStorage');
    return [];
  }

  const psLines = phoneServicesData.data.payload.lines;
  Logger.info(`[LineSelection] Phone Services fallback — found ${psLines.length} lines`);

  return psLines.map((psLine: any, idx: number) => ({
    lineIndex: idx,
    lineLabel: getMultiLineLabel(idx + 1),
    title: getLineTitle(psLine.label, psLine.name, `Line ${idx + 1}`),
    number: psLine.number || '',
    lineType: idx === 0 ? CallerIdLineType.DEFAULT_CLID : CallerIdLineType.ADDITIONAL_NUMBER,
    isSelected: idx === 0, // Default to first line (no server-side selection info)
  }));
}
